<template>
    <div :style="{ textAlign: 'center', marginBottom: '20px', backgroundColor: data.backgroundColor || '#ffffff', padding: '20px', border: data.hasRedLine ? '2px solid red' : 'none', borderRadius: data.hasRedLine ? '8px' : '0' }">
        <a href="#" @click.prevent :style="{ backgroundColor: data.buttonColor || '#2563eb', color: data.textColor || '#ffffff', padding: '12px 24px', borderRadius: '6px', border: `${data.borderWidth || 0}px solid ${data.borderColor || '#000000'}`, textDecoration: 'none', fontWeight: '500', display: 'inline-block' }">
            {{ data.text || 'Lees meer' }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'ButtonBlock',
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        generateHTML() {
            const bgColor = this.data.backgroundColor || '#ffffff';
            const buttonColor = this.data.buttonColor || '#2563eb';
            const textColor = this.data.textColor || '#ffffff';
            const borderColor = this.data.borderColor || '#000000';
            const borderWidth = this.data.borderWidth || 0;
            
            const styleAttr = this.data.hasRedLine
                ? `@if($show_clues) style="background-color: ${bgColor}; padding: 20px; margin-bottom: 20px; border: solid red 2px;" @else style="background-color: ${bgColor}; padding: 20px; margin-bottom: 20px;" @endif`
                : `style="background-color: ${bgColor}; padding: 20px; margin-bottom: 20px;"`;
            
            return `
                <table width="100%" border="0" cellspacing="0" cellpadding="0" ${styleAttr} bgcolor="${bgColor}">
                    <tr>
                        <td align="center" style="padding: 20px;">
                            <table border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td align="center" bgcolor="${buttonColor}" style="background-color: ${buttonColor}; padding: 12px 24px; border: ${borderWidth}px solid ${borderColor};">
                                        <a href="${this.data.url || '#'}" style="color: ${textColor}; text-decoration: none; font-family: Arial, sans-serif; font-size: 14px; font-weight: 500; display: inline-block;">
                                            ${this.data.text || 'Lees meer'}
                                        </a>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            `;
        },
        getDefaultData() {
            return {
                text: 'Lees meer',
                url: '#',
                buttonColor: '#2563eb',
                textColor: '#ffffff',
                backgroundColor: '#ffffff',
                borderColor: '#000000',
                borderWidth: 0,
                hasRedLine: false
            };
        }
    }
}
</script>